import { react, useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import StyledCheckbox from '../StyledExtensions/StyledCheckbox'
import ForgotLogin from './ForgotLogin';
import TokenService from '../../services/TokenService';
import { useSnackbar } from 'notistack';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LoadingIndicator from '../LoadingIndicator'
import InputAdornment from '@mui/material/InputAdornment';
import PersonIcon from '@mui/icons-material/Person';    
import ShieldIcon from '@mui/icons-material/Shield';

import styles from './CustomerLogin.module.css'; // Import css modules stylesheet as styles
const CustomerLogin = (props) => {

    const [email, setEmail] = useState(props.validatedEmail == undefined ? '' : props.validatedEmail);
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showForgotLogin, setShowForgotLogin] = useState('');
    const [formValidation, setFormValidation] = useState({
        isValid: false,
        errors: []
    });
    const [snackbar, setSnackbar] = useState({
        message: '',
        severity: 'info'
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    function handleKeyDown(event) {
        if (event.key === 'Enter') {
            validate();
        }
    }

    function validate() {
        let isValid = true;
        let errors = [];

        if (email.trim() === '') {
            errors["Email"] = "Missing your Email";
            isValid = false;
        }
        else {
            if (!isValidEmail(email.trim())) {
                isValid = false;
                errors["Email"] = "Not a valid email.";

            }
            else {
                if (email.trim().toLowerCase().indexOf('@gmail.') > -1 &&
                    email.trim().toLowerCase().indexOf('@gmail.com') == -1) {
                    isValid = false;
                    errors["Email"] = "Did you mean @gmail.com?";
                }
                else if (email.trim().toLowerCase().indexOf('@yahoo.') > -1 &&
                    email.trim().toLowerCase().indexOf('@yahoo.com') == -1) {
                    isValid = false;
                    errors["Email"] = "Did you mean @yahoo.com?";
                }
                else if (email.trim().toLowerCase().indexOf('@hotmail.') > -1 &&
                    email.trim().toLowerCase().indexOf('@hotmail.com') == -1) {
                    isValid = false;
                    errors["Email"] = "Did you mean @hotmail.com?";
                }
                else if (email.trim().toLowerCase().indexOf('@aol.') > -1 &&
                    email.trim().toLowerCase().indexOf('@aol.com') == -1) {
                    isValid = false;
                    errors["Email"] = "Did you mean @aol.com?";
                }
                else if (email.trim().toLowerCase().indexOf('@comcast.') > -1 &&
                    email.trim().toLowerCase().indexOf('@comcast.net') == -1) {
                    isValid = false;
                    errors["Email"] = "Did you mean @comcast.net?";
                }
                else if (email.trim().toLowerCase().indexOf('@sbcglobal.') > -1 &&
                    email.trim().toLowerCase().indexOf('@sbcglobal.net') == -1) {
                    isValid = false;
                    errors["Email"] = "Did you mean @sbcglobal.net?";
                }
                else if (email.trim().toLowerCase().indexOf('@icloud.') > -1 &&
                    email.trim().toLowerCase().indexOf('@icloud.com') == -1) {
                    isValid = false;
                    errors["Email"] = "Did you mean @icloud.com?";
                }
                else if (email.trim().toLowerCase().indexOf('@outlook.') > -1 &&
                    email.trim().toLowerCase().indexOf('@outlook.com') == -1) {
                    isValid = false;
                    errors["Email"] = "Did you mean @outlook.com?";
                }
                else if (email.trim().toLowerCase().indexOf('@msn.') > -1 &&
                    email.trim().toLowerCase().indexOf('@msn.com') == -1) {
                    isValid = false;
                    errors["Email"] = "Did you mean @msn.com?";
                }

            }
        }

        if (password.trim() === "") {
            isValid = false;
            errors["Password"] = "Missing your Password";
        }

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        if (isValid) {
            setIsLoading(true);
            //TokenService
            let postData = {
                EmailAddress: email,
                Password: password,
                RememberMe: rememberMe ? 'true' : 'false'
            }

            TokenService.customerPost(postData, 'VerifyLoginCredentials', '')
                .then((response) => {
                    if (response !== null) {
                        setIsLoading(false);
                        response = response[Object.keys(response)[0]];
                        if (response.Result === "SUCCESS") {
                            if (response.Message == "Password Validated") {

                                let data = response.JsonData;
                                if (data != '') {
                                    data = JSON.parse(data);
                                }
                                storeLogin(data.WebToken, data.RememberMe);
                              
                                props.LoginChanged();
                            }
                            else if (response.Message == "Invalid Password") {
                                enqueueSnackbar(response.Message, {
                                    variant: 'error',
                                });
                                setPassword('');
                            }
                            else if (response.Message == "Invalid Email Address") {
                                enqueueSnackbar(response.Message, {
                                    variant: 'error',
                                });
                                setEmail('');
                                setPassword('');
                            }
                            else {
                                enqueueSnackbar(response.Message, {
                                    variant: 'error',
                                });
                                setPassword('');
                            }
                           
                        }
                        else if (response.Result === "FAIL") {
                            setIsLoading(false);
                            enqueueSnackbar(response.Message, {
                                variant: 'error',
                            });
                        }
                    }
                })
                .catch((response) => {
                    if (response !== null) {
                        if (response.Result === "FAIL") {
                            enqueueSnackbar('Oops, something went wrong', {
                                variant: 'error',
                            });
                        }

                    }
                });

        }

       
    }

    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    function storeLogin(value, rememberMe, userAccess) {
        if (typeof userAccess === 'string') {
            userAccess = JSON.parse(userAccess);
        }
        localStorage.setItem('Customer',
            JSON.stringify(
                {
                    WebToken: value,
                    RememberMe: rememberMe
                })); // persists after window close

    //if (rememberMe) {
    //    localStorage.setItem('Login', value); // persists after window close
    //}
    //else {
    //    sessionStorage.setItem('Login', value); // removed after window close
    //}
    }

    let loginPanel = null;
    let loadingPanel = null;
    if (isLoading) {
        loadingPanel = <LoadingIndicator Message='Logging In' /> 
    }
    else {
        loginPanel = <div>

            <div className={styles.cardHeader}>Customer Login</div>

            <div className={styles.ContactSectionBody}>
                <TextField className={styles.ContactSectionText} error={formValidation.errors['Email'] !== undefined} label="Email" onChange={(e) => setEmail(e.target.value)} value={email} variant="outlined" onKeyDown={handleKeyDown}

                />
                <div className={styles.FormFieldErrorDescription} style={{ textAlign: 'left' }}> {formValidation.errors['Email'] !== undefined ? formValidation.errors['Email'] : ''}</div>
            </div>

            <div className={styles.ContactSectionBody}>
                <TextField className={styles.ContactSectionText} error={formValidation.errors['Password'] !== undefined} label="Password" onChange={(e) => setPassword(e.target.value)} value={password} variant="outlined" type="password" onKeyDown={handleKeyDown}

                />
                <div className={styles.FormFieldErrorDescription} style={{ textAlign: 'left' }}> {formValidation.errors['Password'] !== undefined ? formValidation.errors['Password'] : ''}</div>
            </div>

            <div className={styles.ContactSectionBody}>
                <div style={{ display: 'flex', justifyContent: 'center' }} >

                    <StyledCheckbox style={{ marginTop: '-15px' }} checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} onKeyDown={handleKeyDown} />
                    <div>
                        Remember Me
                    </div>
                </div>
            </div>



            <Button style={{ marginTop: '15px', alignSelf: 'center' }} variant='contained' color="sipzeeGreen" onClick={() => validate()}>Login</Button>

            <div className={styles.ContactSectionBody}>
                <Button variant='outlined' style={{ marginTop: '15px', alignSelf: 'center' }} onClick={() => setShowForgotLogin('register')}>Register</Button>
            </div>

            <div className={styles.ContactSectionBody}>
                <Button style={{ marginTop: '15px', alignSelf: 'center' }} onClick={() => setShowForgotLogin('password')}>Forgot your password?</Button>
            </div>

        </div>
    }

    return (
        <div>
            <Card sx={{ minWidth: 300, maxWidth: 400, alignSelf: 'center', margin: '10px', marginLeft: 'auto', marginRight: 'auto' }}>
                <CardContent>
                    <div >
                        {loginPanel}
                        {loadingPanel}
                    </div>

                    {showForgotLogin !== '' ?
                        <ForgotLogin onClose={() => setShowForgotLogin('')} viewType={showForgotLogin} />
                        : ""}
                </CardContent>
            </Card>

        </div>
    )

}
export default CustomerLogin;